import PropTypes from "prop-types";
import React from "react";
import styles from "./feeds-seo-size-guide.css";

function FeedsSeoSizeGuide({ sizingChart }) {
    return (
        <div className={styles.sizeGuide}>
            <h3>{sizingChart.title}</h3>
            <p>{sizingChart.body}</p>

            {sizingChart.tables.map((table, tableIndex) => (
                // eslint-disable-next-line react/jsx-key
                <div key={tableIndex} className={styles.sizeGuideContainer}>
                    <h3>{table.title}</h3>
                    <table className={styles.sizeGuideTable}>
                        <tbody>
                            {table.rows.map((row, rowIndex) => {
                                return (
                                    <tr key={tableIndex + "-" + rowIndex}>
                                        {row.map((column, colIndex) =>
                                            rowIndex === 0 ? (
                                                <th
                                                    key={
                                                        tableIndex + "-" + rowIndex + "-" + colIndex
                                                    }
                                                    className={styles.sizeGuideHeading}
                                                >
                                                    {column}
                                                </th>
                                            ) : (
                                                <td
                                                    key={
                                                        tableIndex + "-" + rowIndex + "-" + colIndex
                                                    }
                                                    className={styles.sizeGuideCell}
                                                >
                                                    {column}
                                                </td>
                                            )
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
}

FeedsSeoSizeGuide.propTypes = {
    sizingChart: PropTypes.object,
};

export default FeedsSeoSizeGuide;
